import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3GlobalSettings } from 'ngx-modbus';

export const LANGUAGE_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'language-settings',
  name: 'Language Settings',
  sections: [{
    id: 'language',
    labelKey: 'language',
    registerTable: 'V3GlobalSettings',
    fields: [
      fieldRef(V3GlobalSettings, 'LANG'),
    ],
  }],
};
